import { Address } from 'src/app/models';

interface Colors {
  primary: string;
  secondary: string;
}

export interface UserDto {
  id: number;
  first_name: string;
  last_name: string;
  name: string;
  colour: string; // this is a JSON string, e.g. '{"primary":"#9e9e9e","secondary":"#9e9e9e"}'
  technician: number;
  email: string;
  phone_mobile: string;
  status: number;
  user_created: number;
  prices_flag: boolean;
  other_technicians_flag: boolean;
  calendar_financial_flag: boolean;
  address: Address;
  lat: number;
  long: number;
}

export interface User {
  id?: number;
  firstName: string;
  lastName: string;
  fullName: string;
  initials: string;
  colors: Colors;
  isTechnician: boolean;
  email: string;
  phone: string;
  active: boolean;
  permission: {
    seePrices: boolean;
    seeOtherTechnicians: boolean;
    seeCalendarFinancials: boolean;
  };
  address: Address;
}

export function UserDtoMapper(dto: UserDto): User {
  return {
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    fullName: `${dto.first_name} ${dto.last_name}`,
    initials: `${dto.first_name[0]}${dto.last_name[0]}`,
    colors: parseColor(dto.colour),
    isTechnician: Boolean(dto.technician),
    email: dto.email,
    phone: dto.phone_mobile,
    active: Boolean(dto.status),
    permission: {
      seePrices: Boolean(dto.prices_flag),
      seeOtherTechnicians: Boolean(dto.other_technicians_flag),
      seeCalendarFinancials: Boolean(dto.calendar_financial_flag),
    },
    address: {
      ...dto.address,
      lat: dto.lat,
      long: dto.long,
    },
  };
}

function parseColor(input: unknown): Colors {
  const defaultColor: Colors = { primary: '#000000', secondary: '#000000' };

  if (!input) {
    return defaultColor;
  } else {
    try {
      if (typeof input === 'string') {
        const parsed = JSON.parse(input.replace(/'/g, '"'));
        if (
          parsed &&
          typeof parsed === 'object' &&
          'primary' in parsed &&
          'secondary' in parsed
        ) {
          return parsed as Colors;
        }
        return defaultColor;
      } else if (
        typeof input === 'object' &&
        'primary' in input &&
        'secondary' in input
      ) {
        return input as Colors;
      } else {
        return defaultColor;
      }
    } catch (err) {
      console.error('Failed to parse user color:', input, err);
      return defaultColor;
    }
  }
}
